(function(){

function MainCtrl($http,$scope,$rootScope,$iq_server,$iq_user,$stateParams,$iqaNavigationService,$location,$anchorScroll) {
	$rootScope.iq_serverPath = $iq_server.server();
	$scope.userinfo = {};
	$iq_user.getUserInfo().then(function(re){
		$scope.userinfo = re;
	});
	$rootScope.iq_clientPath = $iq_server.client();
	$scope.apps = [];

	$iqaNavigationService.findNavs().then(function(res){
		$scope.apps = res.data.data.modules.frontNav;
	})

	$scope.gotoState = function(name){
		$location.path(""+name);
	}
	$scope.gotoSelectApp = function(name,event){
		if(event.stopPropagation) {
			event.stopPropagation();		
		}else {		
			event.cancelBubble = true;
		}	
		$('.app-list-modal').addClass('hide');
		$location.path(""+name);
	}

	$scope.orgInfo = {};

	$iq_user.getOrgInfo().then(function(orgInfo){
		$scope.orgInfo = orgInfo;
	})

	//个人主页
	$scope.gotoPersonalPage = function(){
		$location.path("/personalpage/gotouserpage/"+$scope.userinfo.id);
	}
	//个人设置
	$scope.personalSetting = function(name){
		//去除这个是样式为了IE浏览器的情况下左边的定位导航出现的问题
		$('.hp-uc-nav').removeClass('hp-uc-nav-fixed');
		$location.path(""+name);
	}
	//密码设置
	$scope.passwordSetting = function(name){
		$location.path(""+name);
	}

	 $scope.hashScrollTo = function(id) {
		    $location.hash(id);
		    $anchorScroll();
	 };

};

function NavCtrl($scope,$stateParams,$location, $iq_http, $iq_server,$iq_user, $iqaNavigationService, $timeout){
	$scope.newNotice = false;//新通知的小红点
	$scope.newApproved = false;//新审批的小红点
	
	var initNavData = function () {
		$iqaNavigationService.findNavs()
			.then(function (res) {
				var modules = res.data.data.modules.frontNav;
				var navs = res.data.data.navs;
				if (null == navs){
					navs = {};
					navs.items = [
						{label:"收藏",url:"message/store",icon:"star"},
						{label:"通讯录",url:"addressbook",icon:"address-book"},
						{label:"日程安排",url:"schedule",icon:"calendar"},
						{label:"任务管理",url:"task",icon:"set-time"},
						{label:"会议服务",url:"meeting/main",icon:"metting"},
						{label:"文件库",url:"netdisk2",icon:"folder"},
						{label:"个人笔记",url:"note",icon:"notes"}
					];
				}
				var isFound = false;
				for (var i = 0; i < navs.items.length; i++) {
					//如果找到就不从全部应用中去查找，否则查找全部应用
					for (var k = 0; k < modules.length; k++) {
						if (navs.items[i].label == modules[k].label) {
							navs.items[i].icon = modules[k].icon;
							isFound = true;
							break;
						}
					}
					if (!isFound){
						//没有在全部应用里找到模块，就是过期不显示
						if (navs.items[i].type == 'inner'){
							navs.items[i] = undefined;
						}
						else {
							navs.items[i].icon = "star";
						}
					}
					isFound = false;
				}
				var items = [];
				angular.forEach(navs.items, function (v, k, array) {
					if (v){
						items.push(v);
					}
				});
				navs.items = items;
				$scope.navs = navs;
			});
	};

	$scope.gotoState = function(name){
//		if(name == 'message/notice'){
//		}
		$location.path(""+name);
	}

	 // $scope.$watch('newNotice',function(current, old) {
	 // 	if(current == false && old == true){//监控 newNotice变量 如果小红点消失了，就重新开始 长轮询
	 // 		$timeout($scope.getRedPoint(), 2500);
	 // 	}
	 // })
     //
	 // $scope.getRedPoint = function(){//获取小红点
	 // 	var func = {
	 // 			success:function(re){
	 // 				if(re.data.success){
	 // 					if(re.data.data.notice > 0){
	 // 						$scope.newNotice = true;
	 // 					}else{
	 // 						$scope.newNotice = false;
	 // 						$timeout($scope.getRedPoint(), 2500);
	 // 					}
	 // 				}else{
	 // 				}
	 // 			}
	 // 		}
	 // 		var params = {
	 // 			method:"GET",
	 // 			url:$iq_server.server() + "redpoint/data/0"
	 // 		};
	 // 		$iq_http.http(params)
	 // 			.then(func.success)
	 // };
	 // $scope.getRedPoint();//长轮询

	//--------------------------------

	$scope.$on('noticeHaveNew', function(event, temp){//接到广播事件 去掉"我的通知"的小红点
		$scope.newNotice = false;
	});
    $scope.$on('approvedHaveNew', function(event, temp){//接到广播事件 去掉"我的审批"的小红点
    	$scope.newApproved = false;
	});

    $scope.findRedPoint = function (type) {// 查询有没有新消息，触发小红点
        var paramsrp = {
            method: "GET",
            url: $iq_server.server() + "redpoint/data/" + type
        };
        $iq_http.http(paramsrp).then(function (re) {
            if (re.data.success) {
                var redMap = re.data.data;
                if (redMap.notice) {//我的通知
                    if (redMap.notice > 0) {
                        $scope.newNotice = true;
                    } else {
                        $scope.newNotice = false;
                    }
                }
                if (redMap.approved) {//我的审批
                    if (redMap.approved > 0) {
                        $scope.newApproved = true;
                    } else {
                        $scope.newApproved = false;
                    }
                }
            }
        })

    };
	$scope.findRedPoint(100);
    initNavData();
	$scope.userinfo = null;

	$iq_user.getOrgInfo().then(function(orgInfo){
		$scope.orgInfo = orgInfo;
	});

	$iq_user.getUserInfo().then(function(re) {
		$scope.userinfo = re;
		//成功之后id拿回来后调用
//		s.createNoticeListener(re.id,function(res) {
//			$scope.findRedPoint(res.type);
//		});
	});

	//------------------------------
}

function microblogCtrl($scope, $microblogList, $topicList, $window, $modal, $element, $location, $iq_server, $store_service, $iq_popup, $discuss_service, $timeout, $iq_task, $iq_note, $blog_service, $iq_shcedul, $iq_loading){
	$scope.myId = "";
	$scope.myName = "";
	$scope.mydepartment = "";

	$scope.mycountOver = true;//字数超出标志
	$scope.mycounts = 140;//微博最多140字
	$scope.files = [];
	$scope.imgfiles = [];
	//保存标签到各自表中的 示范代码
//	$scope.updateTag = function(obj, tagList){
//		alert('我是ID：' + obj.id + " 的标签");
//		for(var i = 0;i < tagList.length; i++){
//			alert(tagList[i].tag);
//		}
//	}

	$scope.topicList = [];
	$scope.noewTopic = "";

    $(document).one('focus','#publishMessage',
			function(){
    	$("#publishMessage").showAtUsers();//绑定@显示用户列表
    });

    $(document).one('focus','#publishMessage',
			function(){
    	$("#publishMessage").showJing();//绑定#显示话题列表
    });

    $scope.openpic = function (fileName, filePath) {
        var modalInstance = $modal.open({
        	windowClass:'mymodal',
            template: "<div class=\"mskeLayBg\"></div><div class=\"mskelayBox\"><img src=\"" + $iq_server.server() + "uploadController/download?filePath=" + filePath + "&realName=" + fileName + "\" width=\"100%\" height=\"100%\" /><img class=\"mskeClaose\" src=\"img/microblog/mke_close.png\" width=\"27\" height=\"27\" ng-click=\"closepic()\"/></div>",
            controller: microblogPicCtrl,
        });
    };
    var microblogPicCtrl = function ($scope, $modalInstance) {
        $scope.closepic = function () {
            $modalInstance.dismiss('cancel');
        };
    };

    $scope.saySomething = function(){//点击发说说
    	$window.scrollTo(0,0);//回到顶部
    	angular.element("#publishMessage").focus();
    }

    $scope.makeSomeFriend = function(){//点击查找好友
    	$location.path("/addressbook");
    }

  //同步到文件库
    $scope.fileTree = function(file) {
//	    var filetree=$iq_popup.filetree(file.filePath,file.fileName)
	    var filetree=$iq_popup.filetree(file.fileId,file.fileName)
	    filetree.then(function(re){})
    }

    $scope.allBlogList = {};

    $scope.nowpage = 1;
    $scope.pageSize = 15;
    $scope.totalpage = 20;
    $scope.changepages = function(obj) {//分页读取
    	var index = obj.page;
        if (!index) {
            index = 1;
        }
        $scope.nowpage = index;

        var all = $("[name='allType']",$element).get(0);
        var attention = $("[name='attentionType']",$element).get(0);
    	var topicTypeShow = $("[name='topicType']",$element).get(0);

    	if("nav-tab active" == all.className){
    		var getLists = function(tmp){
    		    $scope.allBlogList = tmp.list;
    		    $scope.totalpage = tmp.totalpage;

    			$scope.myId = tmp.myId;
    			$scope.myName = tmp.myName;
    		    $scope.mydepartment = tmp.department;
    		}
    	    var blogParam = {
    	    		"pageNo" : $scope.nowpage,
    	    		"pageSize" : $scope.pageSize,
    	    		"sortInfo" : "DESC_publishTime"
    	    };
    	    $microblogList.getPageList(getLists, blogParam);
    	}else if("nav-tab active" == attention.className){
    		var getAttentionLists = function(tmp){
    		    $scope.allBlogList = tmp.list;
    		    $scope.totalpage = tmp.totalpage;

    			$scope.myId = tmp.myId;
    			$scope.myName = tmp.myName;
    		    $scope.mydepartment = tmp.department;
    		}
    	    var attentionParam = {
    	    		"pageNo" : $scope.nowpage,
    	    		"pageSize" : $scope.pageSize,
    	    		"sortInfo" : "DESC_publishTime"
    	    };
    	    $microblogList.getAttentionList(getAttentionLists, attentionParam);
    	}else if("nav-tab active" == topicTypeShow.className){
    		var getRelativeLists = function(tmp){
    		    $scope.allBlogList = tmp.list;
    		    $scope.totalpage = tmp.totalpage;

    			$scope.myId = tmp.myId;
    			$scope.myName = tmp.myName;
    		    $scope.mydepartment = tmp.department;
    		}
    	    var paramdata = {
    	    		"pageNo" : $scope.nowpage,
    	    		"pageSize" : $scope.pageSize,
    	    		"sortInfo" : "DESC_publishTime",
    	    		"topicName" : "#" + $scope.noewTopic + "#"
    	    };
    	    $microblogList.getTopicsList(getRelativeLists, paramdata);
    	}

    	if(obj != "addNewTask" && obj != "addNewSchedul" ){//新建任务不回到顶部，其他情况回到顶部
    		$window.scrollTo(0,0);//回到顶部
    	}

    }

    $scope.refresh = function(){
        $scope.changepages(1);
    }

	var getLists = function(tmp){
		//$iq_popup.$iq_popup.alert((ImgIputHandler.facePath)[0].faceName);
		//tmp = trans(tmp);//表情 # @等替换处理
	    $scope.allBlogList = tmp.list;
	    $scope.totalpage = tmp.totalpage;

		$scope.myId = tmp.myId;
		$scope.myName = tmp.myName;
	    $scope.mydepartment = tmp.department;

	}
    var blogParam = {
    		"pageNo" : $scope.nowpage,
    		"pageSize" : $scope.pageSize,
    		"sortInfo" : "DESC_publishTime"
    };
    $microblogList.getPageList(getLists, blogParam);


    $scope.nowpagediscuss = 1;
    $scope.pageSizediscuss = 10;
    $scope.totalpagediscuss = 20;

    function trans(tmp){

    	for (var i=0;i<tmp.length;i++)
    	{
    		var blog = tmp[i];

    		//表情处理
    		var reg = new RegExp("\\[[^\\]]*\\]","g"); //创建正则RegExp对象
//    		blog.content = blog.content.replace(reg,'hehe');
    		var faces = blog.content.match(reg);
    		if(faces != null){
        		for (var j=0;j<faces.length;j++) {
        			var imgPath = null;
        			var faceBase = ImgIputHandler.facePath;
        			for(var k=0;k<faceBase.length;k++){
        				var key = "[" + faceBase[k].faceName + "]";
        				if(key == faces[j]){//如果表情库的faceName等于匹配到的表情代码
        					imgPath = faceBase[k].facePath;
        					break;
        				}
        			}

        			if(imgPath == null){//如果没有找到表情

        			}else{
        				blog.content = blog.content.replace(faces[j], "<span class=\"" + imgPath +  "\"/>");//替换表情代码为表情图片链接
        			}

    			}
    		}


    		//#处理
    		var regJing = new RegExp("#[^#\\s&]*#","g"); //创建正则RegExp对象
    		var jings = blog.content.match(regJing);
    		if(jings != null){
        		for (var m=0;m<jings.length;m++) {
        			blog.content = blog.content.replace(jings[m], "<a target=\"_blank\" href=\"" + "http://" + "\">" + jings[m] + "</a>");
        		}
    		}


    		//@处理
    		var regAt = new RegExp("@[^@\\s&]*","g"); //创建正则RegExp对象
    		var ats = blog.content.match(regAt);
    		if(ats != null){
        		for (var n=0;n<ats.length;n++) {
        			blog.content = blog.content.replace(ats[n], "<a target=\"_blank\" href=\"" + "http://" + "\">" + ats[n] + "</a>");
        		}
    		}
    	}

    	return tmp;
    }

    $scope.attentionTemp = 1;
    $scope.changeData = function(type){
    	$scope.nowpage = 1;
    	var topicTypeShow = $("[name='topicType']",$element).get(0);
    	topicTypeShow.className = "nav-tab hide";

    	if(type == "all"){
    		$scope.attentionTemp = 1;
    		var getLists = function(tmp){
    		    $scope.allBlogList = tmp.list;
    		    $scope.totalpage = tmp.totalpage;

    			$scope.myId = tmp.myId;
    			$scope.myName = tmp.myName;
    		    $scope.mydepartment = tmp.department;
    		}
    	    var blogParam = {
    	    		"pageNo" : $scope.nowpage,
    	    		"pageSize" : $scope.pageSize,
    	    		"sortInfo" : "DESC_publishTime"
    	    };
    	    $microblogList.getPageList(getLists, blogParam);
    	}else if(type == "attention"){
    		$scope.attentionTemp = 2;
    		var getAttentionLists = function(tmp){
    		    $scope.allBlogList = tmp.list;
    		    $scope.totalpage = tmp.totalpage;

    			$scope.myId = tmp.myId;
    			$scope.myName = tmp.myName;
    		    $scope.mydepartment = tmp.department;
    		}
    	    var attentionParam = {
    	    		"pageNo" : $scope.nowpage,
    	    		"pageSize" : $scope.pageSize,
    	    		"sortInfo" : "DESC_publishTime"
    	    };
    	    $microblogList.getAttentionList(getAttentionLists, attentionParam);
    	}
    }

    $scope.goPersonelPage = function(userId){
    	$location.path("/personalpage/gotouserpage/" + userId);
    }

    $scope.goBlogDetail = function(blog){
    	var uri = "/personalpage/blogdigital/" + blog.userId + "/" + blog.id;
    	$location.path(uri);
    }

//    $scope.isuploading = false;
//
//    if($scope.isuploading){//附件未上传完毕，阻止提交
//        $iq_popup.alert("请等待附件上传完毕后再提交" ,5 ,'warn');
//        return;
//    }

    //保存说说
	$scope.microblogSave = function(){

		if($scope.mycountOver == false){
			$iq_popup.alert("说说最多可以发表140字，请重新调整！", 3, "warn");
			return;
		}
		var userIdNames = angular.element("#userIdNames").val();
//		alert(userIdNames);
//		return;
		var content = angular.element("#publishMessage").val();
//		var content = $scope.publishMessage;
		var fileLists = $scope.files;
		var imgfileLists = $scope.imgfiles;

		if(content == null || content == undefined || content.trim() == ""){
			if(fileLists != null && fileLists != undefined && fileLists != "undefined"){
				if(fileLists.length > 0){
					content = fileLists[0].fileName + "...等附件";
				}else{
					$iq_popup.alert("请输入内容！", 3, "warn");
					return;
				}
			}else{
				$iq_popup.alert("请输入内容！", 3, "warn");
				return;
			}

		}

		if($scope.publishlist.length < 1){//发布范围
			$iq_popup.alert("请选择发布范围！", 3, "warn");
			return;
		}

    	if($scope.uploading){
            $iq_popup.alert("请等待附件上传完毕后再提交" ,5 ,'warn');
    		return;
    	}

    	if($scope.uploadingimg){
            $iq_popup.alert("请等待图片上传完毕后再提交" ,5 ,'warn');
    		return;
    	}

		var isFile = "N";
		if(fileLists != null && fileLists != undefined && fileLists != "undefined"){
			if(fileLists.length > 0){
				isFile = "Y";
			}
		}
//		var publishTime = getStringDate(new Date());

		content = transBeforeSave(content);//存入数据库之前转换表情 @ #

		var datas = {
				"content" : content,
				"isFile" : isFile,
//				"publishTime": publishTime,
				"relay" : 0,
				"publishScope" : $scope.publishlist,
				"publishScopeName" : $scope.publishnamelist,
				"userIdNames" : userIdNames,
				"attachments" : fileLists,
				"imgList" : imgfileLists
		};

	    var saveOne = function(res){
	    	if(res.data.success == true){
	    		$iq_popup.alert("发布成功！", 3, "success");
	    		$scope.publishMessage = "";
	    		angular.element("#userIdNames").val('');
	    		$scope.mycounts = 140;//微博最多140字
	    		$scope.files = [];
	    		$scope.imgfiles = [];

	    		var newQu = [res.data.data.blog];//把返回结果转换成数组（虽然只有一个，下面调用的方法需要的是数组）
//	    		var newBlog = trans(newQu);//转换表情 @ #
	    		var newBlog =  newQu;
	    		$scope.allBlogList = newBlog.concat($scope.allBlogList);//动态添加新数据

	    		//动态添加话题
	    		if(res.data.data.topic != null){
	    			var newTopic = [res.data.data.topic];
	    			$scope.topicList = $scope.topicList.concat(newTopic);
	    		}

	    	}else{
	    		$iq_popup.alert(res.data.message, 3, "fail");
	    	}
	    	$iq_loading.hide();//隐藏加载
	    }
	    $iq_loading.show();//显示加载
	    $microblogList.save(datas, saveOne);
	}

	$scope.blogDiscuss = function(blog, $index){
		var discussLi = $("[name='discussLi']",$element).get($index);
		if(blog.myblogdiscuss == "yes"){
			blog.myblogdiscuss = "no";
			discussLi.className = "";
		}else{
			blog.myblogdiscuss = "yes";
			discussLi.className = "focus";
		}
	}

	    $scope.showRelay = function (blog) {

	    	$scope.files = [];

	        var relayInstance = $modal.open({
				windowClass: "modal fade mymodal release-reprint-modal",
				templateUrl : "apps/main/main-relay.html",
				controller: relayCtrl,
	        	 resolve:{
	        		 	param:function(){
	        		 		return {
	        		 			"blog": blog,
//	        		 			"mydepartment" : $scope.mydepartment,
//	        		 			"nowScope" : $scope.nowScope,
	        		 			"$parentScope" : $scope
	        		 		};
	        		 	}
	        		 }
	        });
	        relayInstance.opened.then(function(a,b,c){
				$timeout(function(){
					var _m = $(".modal-dialog");
					_m.css({
						"margin-top":"-"+_m.height()/2 + "px",
						"top":"50%"
					})
				})
			});
	    };
	    var relayCtrl = function ($scope, $modalInstance, param, $timeout, $iq_popup) {
	        $(document).one('focus','#relayMessage',
	    			function(){
	        	$("#relayMessage").showAtUsers();//绑定@显示用户列表
	        });
	        $(document).one('focus','#relayMessage',
	    			function(){
	        	$("#relayMessage").showJing();//绑定#显示话题列表
	        });

	        $(document).on('focus','#relayMessage',
	    			function(){
				var text = $("#relayMessage").get(0).placeholder;//处理IE下placeholder不好用的情况
				if ($("#relayMessage").get(0).value === text) {//处理IE下placeholder不好用的情况
					$("#relayMessage").get(0).value = '';
				}
	        });

	        //同步到文件库
	        $scope.fileTree = function(file) {
//	    	    var filetree=$iq_popup.filetree(file.filePath,file.fileName)
	    	    var filetree=$iq_popup.filetree(file.fileId,file.fileName)
	    	    filetree.then(function(re){})
	        }

	    	$scope.relayFlag = "1";
	    	$parentScope = param.$parentScope;
	    	$scope.relayBlog = angular.copy(param.blog);

	    	if($scope.relayBlog.type && $scope.relayBlog.type == "relay"){//新需求，新浪微博的转发~
	    		var relayAdd = '//@' + $scope.relayBlog.content.relay.userName + " : " + $scope.relayBlog.content.relay.content;
//	    		angular.element("#relayMessage").val(relayAdd);
	    		$scope.relayMessage = transDetail(relayAdd);

	    		setTimeout(function(){//将@连接加上
		    		var idnames = "{'id' : '" + $scope.relayBlog.content.relay.userId + "', 'name' : '" + $scope.relayBlog.content.relay.userName + "'}";
		    		angular.element("#userIdNamesRelay").val(angular.element("#userIdNamesRelay").val() + ";" + idnames + ";" + $scope.relayBlog.content.relay.userIdNames);
//		    		$scope.userIdNamesRelay = $scope.relayBlog.content.relay.userIdNames + ";" + idnames;
	    		}, 100);
	    	}

//	    	$scope.mydepartmentRelay = angular.copy(param.mydepartment);
//	    	$scope.nowScopeRelay = angular.copy(param.nowScope);
//	    	$scope.nowScopeRelay = "全公司";
//	    	$scope.publishScopeRelay = ["全公司"];
//	    	$scope.allCompanyRelay = true;
			$timeout(function(){
				angular.element("#relayMessage").focus();
			});

			setTimeout(function(){
				var eleRelay = angular.element("#relayMessage");
				eleRelay.focus();//设置光标

				//设置光标在第一个位置
			        var inpObj = eleRelay.get(0);
			        if(navigator.userAgent.indexOf("MSIE") > -1){
			            var range = document.selection.createRange();
			            var textRange = inpObj.createTextRange();
			            textRange.moveStart('character',0);
			            textRange.collapse();
			            textRange.select();
			        }else{
			            inpObj.setSelectionRange(0,0);
			        }
			   //设置光标在第一个位置--结束
			}, 100);

	        $scope.closeRelay = function () {
	            $modalInstance.dismiss('cancel');
	        };

//	        $scope.changeRelayScope = function(type){
//	        	if(type == "allCompany"){
//	        		if($scope.allCompanyRelay == true){
//	        			$scope.publishScopeRelay = $scope.publishScopeRelay.concat("全公司");
//	        		}else{
//	        			$scope.publishScopeRelay = removeElement($scope.publishScopeRelay, "全公司");
//	        		}
//	        	}else if(type == "department"){
//	        		if($scope.departmentRelay == true){
//	        			$scope.publishScopeRelay = $scope.publishScopeRelay.concat($scope.mydepartmentRelay);
//	        		}else{
//	        			$scope.publishScopeRelay = removeElement($scope.publishScopeRelay, $scope.mydepartmentRelay);
//	        		}
//	        	}else{
//
//	        	}
//
//	    		if($scope.publishScopeRelay.length > 1){
//	    			$scope.nowScopeRelay = $scope.publishScopeRelay.length + "个范围"
//	    		}else if($scope.publishScopeRelay.length == 1){
//	    			$scope.nowScopeRelay = $scope.publishScopeRelay[0];
//	    		}else{
//	    			$scope.allCompanyRelay = true;
//	    			$scope.publishScopeRelay = $scope.publishScopeRelay.concat("全公司");
//	    			$scope.nowScopeRelay = "全公司";
//	    		}
//	        }


	        $scope.relaySave = function(){

				var text = $("#relayMessage").get(0).placeholder;//处理IE下placeholder不好用的情况
				if ($("#relayMessage").get(0).value === text) {//处理IE下placeholder不好用的情况
					$("#relayMessage").get(0).value = '';
				}

	    		var content = angular.element("#relayMessage").val();
	    		var fileLists = $parentScope.files;//取父类scope的文件

	    		var userIdNames = angular.element("#userIdNamesRelay").val();
//	    		alert(userIdNames);
//	    		return;
	    		if(content != null && content != undefined){
	    			content = content.trim();
	    		}

	        	if($parentScope.uploading){
	                $iq_popup.alert("请等待附件上传完毕后再提交" ,5 ,'warn');
	        		return;
	        	}

	    		if(content == null || content == undefined || content == ""){
	    			if(fileLists != null && fileLists != undefined && fileLists != "undefined"){
	    				if(fileLists.length > 0){
	    					content = fileLists[0].fileName + "...等附件";
	    				}else{
	    					$iq_popup.alert("请输入内容！", 3, "warn");
	    					return;
	    				}
	    			}else{
	    				$iq_popup.alert("请输入内容！", 3, "warn");
	    				return;
	    			}

	    		}

	    		if(content != null && content != undefined){
	    			var sum = JudgeLength(content);
	    			if(sum > 140){
	    				$iq_popup.alert("转发最多可以发表140字，请重新调整！", 3, "warn");
	    				return;
	    			}
	    		}

//	    		var publishSP = "";
//	    		var relayValue = angular.element("#relayOfValue").val();
//	    		if(relayValue == "" || relayValue == null){
//	    			$iq_popup.alert("请选择发布范围！", 3, "warn");
//	    			return;
//	    		}else{
//	    			if(relayValue.indexOf("all") != -1 || relayValue.indexOf("全公司") != -1){
//	    				publishSP = ["全公司"];
//	    			}else{
//	    				publishSP = relayValue.split(",");
//	    			}
//	    		}

	    		var isFile = "N";
	    		if(fileLists != null && fileLists != undefined && fileLists != "undefined"){
	    			if(fileLists.length > 0){
	    				isFile = "Y";
	    			}
	    		}

//	    		var publishTime = getStringDate(new Date());

	    		var masterId = $scope.relayBlog.type == "relay" ? $scope.relayBlog.content.relay.masterId : $scope.relayBlog.id;

	    		content = transBeforeSave(content);//存入数据库之前转换表情 @ #

	    		var datas = {
	    				"type" : "relay",
	    				"masterId" : masterId,
//	    				"masterType" : $scope.relayBlog.type,
	    				"content" : content,
	    				"isFile" : isFile,
//	    				"publishTime": publishTime,
	    				"relay" : 0,
//	    				"publishScope" : publishSP,
	    				"publishScope" : $scope.publishlist,
	    				"publishScopeName" : $scope.publishnamelist,
	    				"attachments" : fileLists,
	    				"userIdNames" : userIdNames
	    		};

	    	    var saveOne = function(res){
	    	    	if(res.data.success == true){
	    	    		$iq_popup.alert("发布成功！", 3, "success");
//	    	    		$scope.publishMessage = "";
	    	    		angular.element("#relayMessage").val("");
	    	    		angular.element("#userIdNamesRelay").val("");
	    	    		$parentScope.files = [];

	    	    		var newQu = [res.data.data.blog];//把返回结果转换成数组（虽然只有一个，下面调用的方法需要的是数组）
	    	    		var newBlog =  newQu;
	    	    		$parentScope.allBlogList = newBlog.concat($parentScope.allBlogList);//动态添加新数据

	    	    		for(var i = 0; i < $parentScope.allBlogList.length; i++){
	    	    			var parentBlog = $parentScope.allBlogList[i];
//	    	    			if(parentBlog.id == $scope.relayBlog.id){
	    	    			if(parentBlog.id == masterId){
	    	    				parentBlog.relayTimes = parentBlog.relayTimes + 1; //原微博的转发次数增加1
	    	    				break;
	    	    			}
	    	    		}


	    	    		$modalInstance.dismiss('cancel');

	    	    		//动态添加话题
	    	    		if(res.data.data.topic != null){
	    	    			var newTopic = [res.data.data.topic];
	    	    			$parentScope.topicList = $parentScope.topicList.concat(newTopic);
	    	    		}

	    	    	}else{
	    	    		$iq_popup.alert(res.data.message, 3, "fail");
	    	    	}

	    	    	$iq_loading.hide();//隐藏加载
	    	    }
	    	    $iq_loading.show();//显示加载
	    	    $microblogList.save(datas, saveOne);
	    	}
	    };

	$scope.blogGood = function(blog){//点赞
		var good = {
				"id" : blog.id
		}

		if(blog.goodPeopleId.indexOf($scope.myId) == -1){//点赞
		    var goodFunc = function(res){
		    	if(res.data.success == true){
		    		blog.goodPeopleId = blog.goodPeopleId.concat([$scope.myId]);
		    	}else{
		    		$iq_popup.alert(res.data.message, 3, "fail");
		    	}
		    	$iq_loading.hide();//隐藏加载
		    }
		    $iq_loading.show();//显示加载
		    $microblogList.addGood(good, goodFunc);
		}else{//取消点赞
		    var goodFunc = function(res){
		    	if(res.data.success == true){
		    		blog.goodPeopleId = removeElement(blog.goodPeopleId, $scope.myId);
		    	}else{
		    		$iq_popup.alert(res.data.message, 3, "fail");
		    	}
		    	$iq_loading.hide();//隐藏加载
		    }
		    $iq_loading.show();//显示加载
		    $microblogList.removeGood(good, goodFunc);
		}

	}

	$scope.blogStore = function(blog){//收藏
		$iq_loading.show();//显示加载

		if(blog.storePeopleId.indexOf($scope.myId) == -1){//收藏
//			var nowBlog = blog;
//			if(blog.type == "relay"){
//				nowBlog = blog.content.relay;
//			}else if(blog.type == "discuss"){
//				nowBlog = blog.content.discuss;
//			}else{
//				nowBlog = blog.content;
//			}

			var store = {
					"typeId" : "SS",
					"type" : "说说",
					"objId" : blog.id,
					"obj" : blog,
					"objUrl" : "http://",
					"storeTime" : getStringDate(new Date()),
			}

		    var saveStoreFunc = function(res){
		    	if(res.data.success == true){
		    		$scope.myBlogStore = true;
		    		blog.storePeopleId = blog.storePeopleId.concat([$scope.myId]);
		    	}else{
		    		$iq_popup.alert(res.data.message, 3, "fail");
		    	}
		    	$iq_loading.hide();//隐藏加载
		    }
			$store_service.save(store, saveStoreFunc);
		}else{//取消收藏
			var store = {
					"objId" : blog.id
			}

		    var delStoreFunc = function(res){
		    	if(res.data.success == true){
		    		$scope.myBlogStore = true;
		    		blog.storePeopleId = removeElement(blog.storePeopleId, $scope.myId);
		    	}else{
		    		$iq_popup.alert(res.data.message, 3, "fail");
		    	}
		    	$iq_loading.hide();//隐藏加载
		    }
			$store_service.del(store, delStoreFunc);
		}


	}


	$scope.discussForDiscuss = function(discuss){
		if(discuss.dfdiscuss == "yes"){
			discuss.dfdiscuss = "no";
		}else{
//			angular.element("#discussFDiscuss").css('width','330');
			discuss.dfdiscuss = "yes";
		}
	}

	$scope.delDiscuss = function(blog, discuss){//删除评论
		var confirm = $iq_popup.confirm('确定删除吗?');
        confirm.then(function () {
        	$iq_loading.show();//显示加载

    		var discussParam = {
    				"masterId" : blog.id,
    				"discussId" : discuss.id,
    				"discussType" : "weibo"
    		}

    	    var delDiscussFunc = function(res){
    	    	if(res.data.success == true){
    	    		blog.discussList = removeElementById(blog.discussList, discuss);
    	    		for(var i=0;i<$scope.allBlogList.length;i++){
    	    			if($scope.allBlogList[i].id == blog.id){
    	    				$scope.allBlogList[i] = blog;
    	    				break;
    	    			}
    	    		}
    	    		for(var i=0;i<$scope.allBlogList.length;i++){
    	    			if($scope.allBlogList[i].type == "discuss" && $scope.allBlogList[i].content.discuss.id == discuss.id){
    	    				$scope.allBlogList = removeElementByIndex($scope.allBlogList, i);
    	    				break;
    	    			}
    	    		}
    	    	}
    	    	$iq_loading.hide();//隐藏加载
    	    }
    		$discuss_service.del(discussParam, delDiscussFunc);
    	}, function () {
            console.log('Cancel');
        });

	}

    $scope.confirm = function () {
        var confirm = $iq_popup.confirm('Ok or Cancel ?');
        confirm.then(function () {
            console.log('Ok');
        }, function () {
            console.log('Cancel');
        });
    };
	$scope.delBlogAll = function(blog){
		var confirm = $iq_popup.confirm('确定删除吗?');
        confirm.then(function () {
        	$iq_loading.show();//显示加载
        	var param = {
        			"id" : blog.id
        	};
            var delById = function(tmp){
            	if(tmp.data.success){
            	    $iq_popup.alert("删除成功！", 3, "success");
            	    $scope.allBlogList = removeElementById($scope.allBlogList, blog);//删除微博
            	    //删除微博下属的评论
            	    for(var i = 0; i < $scope.allBlogList.length; i++){
            	    	var blogAll = $scope.allBlogList[i];
            	    	if(blogAll.type == "discuss" && blogAll.content.discuss.masterId == blog.id){
            	    		$scope.allBlogList = removeElementByIndex($scope.allBlogList, i);//删除微博下属的评论
            	    		i--;
            	    	}
            	    }
            	}else{
            		$iq_popup.alert(tmp.data.message, 3, "fail");
            	}
            	$iq_loading.hide();//隐藏加载
            }
            $microblogList.del(param, delById);
    	}, function () {
            console.log('Cancel');
        });

	}

	$scope.newTask = function(){
		$location.path("/task/publish");
	}

	$scope.missionNewTaskAddContent = function(blog){
//		$location.path("/task/publish");
		var detail = "";
		var attachments = [];
		var type = blog.type;
    	if(type == "blog"){
    		detail = blog.content.content;
    		attachments = blog.content.attachments;
    	}else if(type == "discuss"){
    		detail = blog.content.discuss.content;
    		attachments = blog.content.discuss.attachments;
    	}else if(type == "discussmaster"){
    		detail = blog.content.master.content;
    		attachments = blog.content.master.attachments;
    	}else if(type == "relay"){
    		detail = blog.content.relay.content;
    		attachments = blog.content.relay.attachments;
    	}else if(type == "relaymaster"){
    		detail = blog.content.master.content;
    		attachments = blog.content.master.attachments;
    	}else if(type == "task"){
    		detail = blog.userName + "：" + blog.content.content;
    		attachments = blog.content.attachments;
    	}else if(type == "schedule"){
    		detail = blog.userName + "：" + blog.content.content;
    		attachments = blog.content.attachments;
    	}else if(type == "discussshow"){
    		detail = blog.content;
    		attachments = blog.attachments;
    	}

    	detail = transDetail(detail);//替换

		var obj={
			"detail" : detail,
//			"attachFiles" : attachments
		};
		var getNewTask = $iq_task.openDialog(obj);
		getNewTask.then(function(value){
			if(value == 'ok'){
//				$rootScope.$broadcast('refreshBlog', '');//广播时间  刷新说说
				$scope.changepages("addNewTask");
			}
		})
	}

	$scope.schedulAddContent = function(blog){
//		$location.path("/task/publish");
		var detail = "";
		var attachments = [];
		var type = blog.type;
    	if(type == "blog"){
    		detail = blog.content.content;
    		attachments = blog.content.attachments;
    	}else if(type == "discuss"){
    		detail = blog.content.discuss.content;
    		attachments = blog.content.discuss.attachments;
    	}else if(type == "discussmaster"){
    		detail = blog.content.master.content;
    		attachments = blog.content.master.attachments;
    	}else if(type == "relay"){
    		detail = blog.content.relay.content;
    		attachments = blog.content.relay.attachments;
    	}else if(type == "relaymaster"){
    		detail = blog.content.master.content;
    		attachments = blog.content.master.attachments;
    	}else if(type == "task"){
    		detail = blog.userName + "：" + blog.content.content;
    		attachments = blog.content.attachments;
    	}else if(type == "schedule"){
    		detail = blog.userName + "：" + blog.content.content;
    		attachments = blog.content.attachments;
    	}else if(type == "discussshow"){
    		detail = blog.content;
    		attachments = blog.attachments;
    	}

    	detail = transDetail(detail);//替换

		var obj={
			"content" : detail,
//			"attachFiles" : attachments
		};
		var getNewShcedul = $iq_shcedul.openDialog(obj);
		getNewShcedul.then(function(value){
			if(value == 'ok'){
//				$rootScope.$broadcast('refreshBlog', '');//广播时间  刷新说说
				$scope.changepages("addNewSchedul");
			}
		})
	}


	$scope.noteAddContent = function(blog){
		var detail = "";
		var type = blog.type;
    	if(type == "blog"){
    		detail = blog.content.content;
    	}else if(type == "discuss"){
    		detail = blog.content.discuss.content;
    	}else if(type == "discussmaster"){
    		detail = blog.content.master.content;
    	}else if(type == "relay"){
    		detail = blog.content.relay.content;
    	}else if(type == "relaymaster"){
    		detail = blog.content.master.content;
    	}else if(type == "task"){
    		detail = blog.userName + "：" + blog.content.content;
    	}else if(type == "schedule"){
    		detail = blog.userName + "：" + blog.content.content;
    	}else if(type == "discussshow"){
    		detail = blog.content;
    	}

    	detail = transDetail(detail);//替换
		var obj={
			"content" : detail
		};
		$iq_note.openDialog(obj);

	}

	function transDetail(detail){
		detail = detail.replace(new  RegExp("&nbsp;", "g")," ");//替换空格
		detail = detail.replace(new  RegExp("<a[^>]*>", "g"),"");//替换a标签
		detail = detail.replace(new  RegExp("<\/a>", "g"),"");//替换a标签

		//表情处理
		var reg = new RegExp("<img[^>]*\/>","g"); //创建正则RegExp对象
		var faces = detail.match(reg);
		if(faces != null){
			for (var j=0;j<faces.length;j++) {
				var imgName = null;
				var faceBase = ImgIputHandler.facePath;
				for(var k=0;k<faceBase.length;k++){
					var path = "<span class=\"" + faceBase[k].facePath + "\"/>";
					if(path == faces[j]){//如果表情库的facePath等于匹配到的表情代码
						imgName = faceBase[k].faceName;
						break;
					}
				}

				if(imgName != null){//如果找到表情
					detail = detail.replace(faces[j], "[" + imgName +  "]");//替换
				}

			}
		}

		return detail;
	}

	{//话题

	    var getLists = function(tmp){
		    $scope.topicList = tmp;

	    }
	    $topicList.getAllList(getLists);


	    $scope.topicRelations = function(topic){
	    	$scope.noewTopic = topic;
//	    	var paramdata = {"topicId" : topicId};
//		    var getRelativeLists = function(tmp){
//			    $scope.allBlogList = tmp.list;
//			    $scope.totalpage = tmp.totalpage;
//
//		    }
//	    	$topicList.getTopicRelations(getRelativeLists, paramdata);
	    	$scope.nowpage = 1;
    		var getRelativeLists = function(tmp){
    		    $scope.allBlogList = tmp.list;
    		    $scope.totalpage = tmp.totalpage;

    			$scope.myId = tmp.myId;
    			$scope.myName = tmp.myName;
    		    $scope.mydepartment = tmp.department;
    		}
    	    var paramdata = {
    	    		"pageNo" : $scope.nowpage,
    	    		"pageSize" : $scope.pageSize,
    	    		"sortInfo" : "DESC_publishTime",
    	    		"topicName" : "#" + topic + "#"
    	    };
    	    $microblogList.getTopicsList(getRelativeLists, paramdata);


	    	var topicTypeShow = $("[name='topicType']",$element).get(0);
	    	var allTypeShow = $("[name='allType']",$element).get(0);
	    	var attentionTypeShow = $("[name='attentionType']",$element).get(0);
	    	allTypeShow.className = "nav-tab";
	    	attentionTypeShow.className = "nav-tab";
	    	topicTypeShow.className = "nav-tab active";


	    }

	    $scope.openpictopic = function (fileName, filePath) {
	        var modalInstance = $modal.open({
	            template: "<div class=\"mskeLayBg\"></div><div class=\"mskelayBox\"><img src=\"" + $iq_server.server() + "uploadController/download?filePath=" + filePath + "&realName=" + fileName + "\" width=\"100%\" height=\"100%\" /><img class=\"mskeClaose\" src=\"img/microblog/mke_close.png\" width=\"27\" height=\"27\" ng-click=\"closepic()\"/></div>",
	            controller: microblogPicCtrl,
	        });
	    };
	    var microblogPicCtrl = function ($scope, $modalInstance) {
	        $scope.closepic = function () {
	            $modalInstance.dismiss('cancel');
	        };
	    };
	}

	//判断输入字符的长度
	$scope.judgeCount = function(){
//		var str = angular.element("#publishMessage").val();;
		var str = $scope.publishMessage;
		if(str != null && str != undefined){
			var sum = JudgeLength(str);
			if(sum > 140){
				$scope.mycountOver = false;
				$scope.mycounts = Math.ceil(sum - 140);
			}else{
				$scope.mycountOver = true;
				$scope.mycounts = Math.floor(140 - sum);
			}
		}
	}

	$scope.$on('refreshBlog', function(event, temp){
		$scope.changepages("addNewTask");
	});

};

function topicCtrl($scope, $modal, $topicList, $iq_server, $iq_popup){//以前话题单独展示页面用的，现在 无用！

	$scope.allList = "";
    var getLists = function(tmp){
	    $scope.allList = tmp;

    }
    $topicList.getAllList(getLists);

	$scope.topicRelativeList = "";
    var getRelativeLists = function(tmp){
	    $scope.topicRelativeList = tmp;

    }
    $scope.topicRelations = function(topicId, topic){
    	$scope.noewTopic = topic;
    	var paramdata = {"topicId" : topicId};
    	$topicList.getTopicRelations(getRelativeLists, paramdata);
    }

    $scope.openpictopic = function (fileName, filePath) {
        var modalInstance = $modal.open({
            template: "<div class=\"mskeLayBg\"></div><div class=\"mskelayBox\"><img src=\"" + $iq_server.server() + "uploadController/download?filePath=" + filePath + "&realName=" + fileName + "\" width=\"100%\" height=\"100%\" /><img class=\"mskeClaose\" src=\"img/microblog/mke_close.png\" width=\"27\" height=\"27\" ng-click=\"closepic()\"/></div>",
            controller: microblogPicCtrl,
        });
    };
    var microblogPicCtrl = function ($scope, $modalInstance) {
        $scope.closepic = function () {
            $modalInstance.dismiss('cancel');
        };
    };

}


function labelCtrl($scope, $modal, $labelList, $iq_server, $iq_popup){

	$scope.allList = "";
    var getLists = function(tmp){
	    $scope.allList = tmp;

    }
    $labelList.getAllList(getLists);

	$scope.labelRelativeList = "";
    var getRelativeLists = function(tmp){
	    $scope.labelRelativeList = tmp;

    }
    $scope.labelRelations = function(labelId){
    	var paramdata = {"labelId" : labelId};
    	$labelList.getLabelRelations(getRelativeLists, paramdata)
    }

    $scope.openpiclabel = function (fileName, filePath) {
        var modalInstance = $modal.open({
            template: "<div class=\"mskeLayBg\"></div><div class=\"mskelayBox\"><img src=\"" + $iq_server.server() + "uploadController/download?filePath=" + filePath + "&realName=" + fileName + "\" width=\"100%\" height=\"100%\" /><img class=\"mskeClaose\" src=\"img/microblog/mke_close.png\" width=\"27\" height=\"27\" ng-click=\"closepic()\"/></div>",
            controller: labelPicCtrl,
        });
    };
    var labelPicCtrl = function ($scope, $modalInstance) {
        $scope.closepic = function () {
            $modalInstance.dismiss('cancel');
        };
    };

}

function PortalCtrl($scope, $modal, $portalList, $iq_server, $location, $iq_popup){
	$scope.items = {};
	var param = {//没有参数，默认七条，按置顶 时间倒序
    };
	var getnewsLists = function(tmp){
		$scope.items = tmp.list;
    }
	$portalList.getNewsList(getnewsLists,param);

	//点击新闻标题进入新闻页面
    $scope.gotoNews = function(news){
    	$location.path("/news/content/" + news.id);
    }

	//点击新闻“更多”
    $scope.goMoreNews = function(){
    	$location.path("/news/listandset");
    }
}

//首页我的日程，动态显示
function scheduleCtrl($scope, $modal, $iq_schedul_service, $iq_server, $element, $iq_popup, $location, $iq_shcedul, $rootScope){
	$scope.datetimelist = [];
	$scope.flag = {};
	$scope.mytoday = "";
	var date = new Date();
	var year = date.getFullYear();
	var month = date.getMonth()+1;
	var today =  date.getDate() < 10 ? ("0" + date.getDate()) : date.getDate();
	var weeks = new Array("周日","周一","周二","周三","周四","周五","周六");
	var first_date = new Date(year,month,1);                //取当年当月中的第一天
	var first_date_nextm = new Date(year,month+1,1)         //取当年下个月的第一天
	var date_count =   (new Date(first_date.getTime()-1000*60*60*24)).getDate();//获取当月的天数
	var last_date =   new Date(first_date.getTime()-1000*60*60*24);//获得当月最后一天的日期
	if(date.getDate()+4 <= date_count){
		$scope.datetimelist=[
		                     {"week":weeks[date.getDay()], "month":month,
		                    	 "day":( date.getDate() < 10 ? ("0" + date.getDate()) : date.getDate() )},
		                    	 {"week":weeks[(date.getDay()+1)%7], "month":month,
			                    	 "day":( (date.getDate()+1) < 10 ? ("0" + (date.getDate()+1)) : (date.getDate()+1)  )},
			                    	 {"week":weeks[(date.getDay()+2)%7], "month":month,
				                    	 "day":( (date.getDate()+2) < 10 ? ("0" + (date.getDate()+2)) : (date.getDate()+2) )},
				                    	 {"week":weeks[(date.getDay()+3)%7], "month":month,
					                    	 "day":( (date.getDate()+3) < 10 ? ("0" + (date.getDate()+3)) : (date.getDate()+3) )},
					                    	 {"week":weeks[(date.getDay()+4)%7], "month":month,
						                    	 "day":( (date.getDate()+4) < 10 ? ("0" + (date.getDate()+4)) : (date.getDate()+4) )},
		                     ];
		$scope.flag = $scope.datetimelist[0];
	}else if(date.getDate()+4 > date_count){
		var dayslast = date_count - date.getDate() + 1; //当月剩余天数
		for(var i=0;i<dayslast;i++){
			$scope.datetimelist.push({"week":weeks[(date.getDay()+i)%7], "month":month, "day":( (date.getDate()+i) < 10 ? ("0" + (date.getDate()+i)) : (date.getDate()+i) )});
		}
		var n = 1;
		for(var j=dayslast;j<5;j++){
			$scope.datetimelist.push({"week":weeks[(date.getDay()+j)%7], "month":month+1, "day":( n < 10 ? ("0" + n) : n  )});
			n++;
		}

		$scope.flag = $scope.datetimelist[0];
	}

	$scope.mytoday = year + "-" + (month < 10 ? ("0" + month) : month) + "-" + today;

	$scope.activeDay = function(datetime){
		$scope.flag = datetime;
		$scope.mytoday = year + "-" + (datetime.month < 10 ? ("0" + datetime.month) : datetime.month) + "-" + datetime.day;
		$scope.getTodayFive();
	}

	$scope.listisnullornot = 1;

	$scope.schedullist = [];

	$scope.getTodayFive = function(){
		var getFive = function(tmp){
			$scope.schedullist = tmp.data.data.content;
			//判断任务集合是否为空，初始化相应的ng-if
			if(tmp.data.data.content.length>0){
				$scope.listisnullornot = 0;
			}else{
				$scope.listisnullornot = 1;
			}
	    }
		$iq_schedul_service.list($scope.mytoday, getFive);
	}
	$scope.getTodayFive();

	$scope.toSchdulDetail = function(id){
		$location.path("/schedule/detail/" + id);
	}

	$scope.scheduleNew = function(){
		var obj={};
		var getNewShcedul = $iq_shcedul.openDialog(obj);
		getNewShcedul.then(function(value){
			if(value == 'ok'){
				$scope.getTodayFive();
				$rootScope.$broadcast('refreshBlog', '');//广播时间  刷新说说
			}
		});
	}

	$scope.goSchedul = function(){
		$location.path("/schedule/list");
	}
}


//首页我的任务，动态显示
function MissionCtrl($scope, $modal, $iqa_task_common_service, $iq_server, $element, $iq_popup, $location, $iq_task, $rootScope){
	$scope.listisnullornot = 1;
	$scope.missionlist = {};
	var getfiveTasks = function(tmp){
		$scope.missionlist = tmp;
		//判断任务集合是否为空，初始化相应的ng-if
		if(tmp.length>0){
			$scope.listisnullornot = 0;
		}else{
			$scope.listisnullornot = 1;
		}
	}
	$iqa_task_common_service.findTopFive(getfiveTasks);

	//鼠标划动效果,ng-mouseenter
	$scope.taskhover = function (inli){
		var className = inli.target.className;
		if(className.indexOf("active") == -1){
			var li = $("[name='taskli']",$element);
			for(var i = 0 ; i<li.length; i ++){
				if(li[i].className.indexOf("active") != -1){
					li[i].className = li[i].className.replace("active", "");
				}
			}
			inli.target.className = inli.target.className + " active";
		}
	}


	$scope.missionNewTask = function(){
//		$location.path("/task/publish");
		var obj={};
		var getNewTask = $iq_task.openDialog(obj);
		getNewTask.then(function(value){
			if(value == 'ok'){
				$iqa_task_common_service.findTopFive(getfiveTasks);
				$rootScope.$broadcast('refreshBlog', '');//广播时间  刷新说说
			}
		})
	}

	$scope.toTaskDetail = function(id){
		$location.path("/task/detail/" + id);
	}

	$scope.goTask = function(){
		$location.path("/task");
	}
}


//首页搜索
function headerControler($scope, $modal, $iq_user,$iq_server, $iq_popup,$location,$rootScope,$iq_http,$rootScope,$timeout,$changeOrgService,$inviteService,$ocLazyLoad){
	$scope.headerTab = "main";

	var getOrgs = function(){
		$changeOrgService.getOrgs(function(data){
			if (data.status == 200) {
				$scope.orgs = angular.copy(data.data);
			}
		},"status-filter:1")
	}
	getOrgs();
	$scope.changeOrg = function(){
		var modalInstance = $modal.open({
			templateUrl : $iq_server.client() + 'templates/frame/orgs-to-change.html',
			controller : modalInstanceCtrl,
			scope : $scope,
			windowClass : "modal fade mymodal"
		});
		modalInstance.opened.then(function(a,b,c){
			$timeout(function(){
				var _m = $(".modal-dialog");
				_m.css({
					"margin-top":"-"+_m.height()/2 + "px",
					"top":"50%"
				})
			})
		})
	}

	$scope.invite = function(){

		$iq_user.getOrgInfo().then(function(orgInfo){
			$scope.orgName = orgInfo.orgName;
			$scope.orgCode = orgInfo.orgCode;
		});
		
		$ocLazyLoad.load(['/components/invitemodal/invitemodal.css']);
		var obj = {
			label : '邀请用户',
			okName : "保存",
			cancelName : "取消"
		};
		var modalInstance = $modal.open({
			templateUrl : $iq_server.client() + 'templates/frame/iq_invitewindow.html',
			controller : inviteModalInstanceCtrl,
			scope : $scope,
			windowClass : "modal fade mymodal",
			resolve : {
			options : function() {
				return obj;
			}
		},
		});
		modalInstance.opened.then(function(a,b,c){
			$timeout(function(){
				var _m = $(".modal-dialog");
				// alert(_m.html());
				// alert(_m.height());
				_m.css({
					"margin-top":"-"+_m.height()/2 + "px",
					"top":"50%"
				})
			})
		})
	}

	var inviteModalInstanceCtrl = function($scope, $modalInstance,options,$iq_server){
		var pageOptions = {'mainPage' : 0,
				           'weiPage' : 1,
				           'linkPage' : 2,
				           'phonePage' : 3,
				           'copylPage' : 4};

		var objOptions = [{
			label : '邀请用户',
			okName : "保存",
			cancelName : "取消"
		},{
			label : '微信邀请',
			sendName : "完成"
		},{
			label : '二维码邀请',
			sendName : "完成"
		},{
			label : '手机号码邀请',
			sendName : "邀请"
		},{
			label : '复制链接',
			sendName : "完成"
		}];

		function utf16to8(str) {
			var out, i, len, c;
			out = "";
			len = str.length;
			for (i = 0; i < len; i++) {
				c = str.charCodeAt(i);
				if ((c >= 0x0001) && (c <= 0x007F)) {
					out += str.charAt(i);
				} else if (c > 0x07FF) {
					out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F));
					out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F));
					out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
				} else {
					out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F));
					out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
				}
			}
			return out;
		}

		function doBase64Encode(str) {
			var result = base64Encode(utf16to8(str));
			result = result.replace(/=/g, "!");
			result = result.replace(/\//g, "@");
			result = result.replace(/\+/g, "-");
			return result;
		}

		var userName = doBase64Encode($scope.userinfo.name);
		var orgName = doBase64Encode($scope.orgInfo.orgName);

		$scope.inviteUrl = $location.protocol() + "://" + $location.host() + ":" + $location.port() + "/login/register-or-login-join/"+userName+"/"+$scope.orgInfo.orgCode;
		$scope.srcUrl = $iq_server.server() + "person/inviteQrcode?width=150&url="+encodeURIComponent($scope.inviteUrl);
		$scope.currentPage = pageOptions.mainPage;
		$scope.options = objOptions[0];

		//复制到剪切板
		$scope.clikSuccess = function(){
			$scope.copyShow = true;
			$timeout(function(){
				$scope.copyShow = false;
			},1000);
		}
		$scope.fallback = function(){
			$scope.copyFalseShow = true;
			$timeout(function(){
				$scope.copyFalseShow = false;
			},3000);
		}
		$scope.changePage = function(option){
			$scope.options = objOptions[option];
			$scope.currentPage = option;
			if(option == 2){

			}
		}
		$scope.close = function() {
			$modalInstance.dismiss('close');
		};
		$scope.ok = function() {
			switch($scope.currentPage){
				case 1:
					$scope.close();
					break;
				case 2:
					$scope.close();
					break;
				case 3:
					break;
				default:
					$scope.close();
					break;
			}

		}
		$scope.inviteMobiles = [{"mobile":""},{"mobile":""},{"mobile":""},{"mobile":""}];

		$scope.addLines = function(line) {
			while (line > 0) {
				$scope.inviteMobiles.push({
					mobile : ""
				});
				line--;
			}
		}

		$scope.doInvite = function(form){
			if(form.$invalid){
				// $iq_popup.alert("您输入的手机号存在格式问题",3,"warn");
				$iq_popup.my_alert_invite("您输入的手机号存在格式问题",3,"warn");
			}
			$inviteService.invite($scope.inviteMobiles).then(function(data){
				if (data.data.status == 200) {
					// $iq_popup.alert("邀请"+data.data.message,3,"success");
						$iq_popup.my_alert_invite("邀请"+data.data.message,3,"success");
				}else{
					// $iq_popup.alert("邀请"+data.data.message,3,"warn");
						$iq_popup.my_alert_invite("邀请"+data.data.message,3,"warn");
				}
				$scope.cancel();
			},function(){$scope.cancel();})
		}

		$scope.cancel = function() {
			$modalInstance.dismiss('cancel');
		};
	}

	var modalInstanceCtrl = function($scope, $modalInstance){
		$scope.switchOrg = function(_id){
			$changeOrgService.switchOrg(function(data){
				if (data.status == 200) {
					if(data.data.init==false){
						//location.href=$iq_server.client()+"/setting-guide/step1";
						$location.path("/setting-guide/step1");
					}else{
						location.href=$iq_server.client();
					}

				}else{
					location.href=$iq_server.client()+"../login/";
				}
				$scope.cancel();
			},_id)
		}

		$scope.cancel = function() {
			$modalInstance.dismiss('cancel');
		};
	}


	function changeTab (url){
    	if(url == "/"){
    		$scope.headerTab = "";
    	}
    	else if(url.indexOf("/istore") == 0){
    		$scope.headerTab = "store";
    	}
    	else{
    		$scope.headerTab = "app";
    	}
	}
	changeTab($location.path());
    $rootScope.$on('$stateChangeSuccess',function(event, toState, toParams, fromState, fromParams){
    	changeTab(toState.url);
    })


	$scope.showSearch = false;
	$scope.exit = function(){
		$iq_http.http({
			url:$iq_server.server()+"logout",
			method:"POST"
		}).then(function(data){
	    	if(document.domain=="iquicker.digitalchina.com"){
	    		location.href="http://dcone.digitalchina.com/itim/self/SSOLogoff.jsp";
	    	} else if(document.domain=="iquicker.dcits.com"){
	    		location.href="http://home.dcits.com/itim/self/SSOLogoff.jsp";
	    	} else{
	    		location.href=$iq_server.client()+"../welcome";
	    	}
		},function(){
			$iq_popup.alert("注销失败，请确认网络连接后重试",3,"fail");
		})
	}
	$scope.search=function(){
		$rootScope.$broadcast("to_child_search",$scope.searchKey);
		//将查询条件传到下一个页面
		$rootScope.searchKey=$scope.searchKey;
		$location.path("/search");
		$scope.showSearch = false;
	}

	$scope.cancelSearch = function(){
		$scope.showSearch = false
	}	
}

angular
    .module('home')
    .controller('MainCtrl', MainCtrl)
	.controller('NavCtrl', NavCtrl)
	.controller('headerControler', headerControler)

	.controller('topicCtrl', topicCtrl)
	.controller('labelCtrl', labelCtrl)
	.controller('microblogCtrl', microblogCtrl)
	.controller('PortalCtrl', PortalCtrl)
	.controller('scheduleCtrl', scheduleCtrl)
	.controller('MissionCtrl', MissionCtrl)

//	.controller('PlanCtrl', PlanCtrl)
	.filter(
			'mto_trusted', ['$sce', function ($sce) {
				return function (text) {
		    		return $sce.trustAsHtml(text);
		    	}
			}]
		);

})()
